/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Trial_NoteInputs */

const en_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payment required for 7 days`)
};

const fr_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun paiement requis pendant 7 jours`)
};

const de_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 Tage lang keine Zahlung erforderlich`)
};

const it_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun pagamento richiesto per 7 giorni`)
};

const ru_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплата не требуется в течение 7 дней.`)
};

const es_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se requiere pago durante 7 días`)
};

const zh_cn2_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7天内无需付款`)
};

const ja_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7日間は支払い不要`)
};

const hi_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 दिनों तक कोई भुगतान आवश्यक नहीं है`)
};

const pt_pt2_signup_trial_note = /** @type {(inputs: Signup_Trial_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum pagamento é necessário por 7 dias.`)
};

/**
* | output |
* | --- |
* | "No payment required for 7 days" |
*
* @param {Signup_Trial_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_trial_note = /** @type {((inputs?: Signup_Trial_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Trial_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_trial_note(inputs)
	if (locale === "de") return de_signup_trial_note(inputs)
	if (locale === "it") return it_signup_trial_note(inputs)
	if (locale === "ru") return ru_signup_trial_note(inputs)
	if (locale === "es") return es_signup_trial_note(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_trial_note(inputs)
	if (locale === "ja") return ja_signup_trial_note(inputs)
	if (locale === "hi") return hi_signup_trial_note(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_trial_note(inputs)
	return en_signup_trial_note(inputs)
});